import { motion } from "motion/react";
import { Icon, type IconName } from "../../components/Icon";
import { CachedMedia } from "./CachedMedia";
import { haptic } from "../../telegram/haptics";
import { openExternal } from "../../telegram/webapp";
import { pressRow } from "../../motion";
import { formatBytes } from "../../i18n/format";
import { useT } from "../../i18n/strings";
import type { Attachment } from "../../api/types";
import s from "../artworks/detail.module.css";

function markFor(mime: string): IconName {
  if (mime.startsWith("image/")) return "image";
  if (mime.startsWith("video/")) return "video";
  return "file";
}

export function AttachmentList({ files, emptyText }: { files: Attachment[]; emptyText?: string }) {
  const t = useT();
  if (!files.length) {
    return <p className={s.rowValueMuted}>{emptyText ?? t.detail.noFiles}</p>;
  }

  return (
    <div className={s.files}>
      {files.map((file) => (
        <motion.button
          key={file.id}
          type="button"
          className={`${s.file} paper hoverable`}
          {...pressRow}
          onClick={() => {
            haptic.tap();
            // `download=1` makes the API answer with a Content-Disposition, so
            // a PDF is saved rather than half-rendered in a WebView.
            openExternal(`${file.url}&download=1`);
          }}
        >
          <span className={s.fileMark}>
            <CachedMedia
              media={file}
              prefer="thumbnail"
              className={s.filePreview}
              fallback={<Icon name={markFor(file.mime_type)} size={20} />}
            />
          </span>
          <span className={s.fileBody}>
            <span className={`${s.fileName} bidi`}>{file.original_filename || file.mime_type}</span>
            {file.caption && <span className={s.fileCaption}>{file.caption}</span>}
            <span className={s.fileMeta}>{formatBytes(file.size_bytes)}</span>
          </span>
          <Icon name="forward" size={16} />
        </motion.button>
      ))}
    </div>
  );
}
